import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Routes, Route, } from "react-router-dom";

// import components
import Header from './components/Header';
import Hero from './components/Hero';
import Brands from './components/Brands';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Skills from './components/Skills';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Testimonials from './components/Testimonials';
import BackTopBtn from './components/BackTopBtn';
import Blogs from './components/Blogs';
import Home from './components/Home';
import ProjectDetails from './components/ProjectDetails';

const App = () => {
  return (
    <div className='bg-white relative'>
      <Header />
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='blogs' element={<Blogs></Blogs>}></Route>
        <Route path='projectDetails/:id' element={<ProjectDetails></ProjectDetails>}></Route>
      </Routes>
      <Footer />
      <BackTopBtn />
      <ToastContainer />
    </div>
  );
};

export default App;
